import { useMemo } from 'react';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { useDisplayInteractiveEducation } from '../../hooks/hooks';
import { useGenerateAsyncQuizMe } from '../../hooks/useGenerateAsyncQuizMe';
import { OverviewModalAssessmentTitleContainer } from './OverviewModalAssessmentTitleContainer';
import QuizMeTabContainer from '../QuizMeTabContainer';
import { useFullLesson } from '../../../lessons/lessonQueries';
import { buildInteractiveContentTrackingProps, extractVideoMetadata } from '../../utils/contentUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OverviewModalAssessmentQuizMeContainer = ({
  contentId: lessonId,
  contentType,
  language,
  onEnroll
}) => {
  const {
    lesson
  } = useFullLesson(lessonId, language);
  const {
    professorId
  } = useMemo(() => extractVideoMetadata(lesson || undefined), [lesson]);
  const interactiveContentTrackingProps = useMemo(() => buildInteractiveContentTrackingProps(lesson || undefined, contentType, lessonId, professorId), [lesson, contentType, lessonId, professorId]);
  const {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation
  } = useDisplayInteractiveEducation(interactiveContentTrackingProps);
  const {
    onAsyncRegenerateQuiz,
    generateQuizError,
    generateQuizLoading
  } = useGenerateAsyncQuizMe({
    primaryContentId: lessonId,
    contentType,
    interactiveContentTrackingProps,
    language
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OverviewModalAssessmentTitleContainer, {
      contentId: lessonId,
      displayInteractiveEducation: displayInteractiveEducation,
      handleDisplayInteractiveEducation: handleDisplayInteractiveEducation,
      onEnroll: onEnroll
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      open: displayInteractiveEducation === 'QUIZ_ME',
      children: /*#__PURE__*/_jsx(QuizMeTabContainer, {
        additionalTracking: interactiveContentTrackingProps,
        asyncGenerateError: !!generateQuizError,
        asyncGenerateLoading: generateQuizLoading,
        contentType: contentType,
        onAsyncRegenerateQuiz: onAsyncRegenerateQuiz,
        primaryContentId: lessonId
      })
    })]
  });
};
export default OverviewModalAssessmentQuizMeContainer;